define("settings/utils/string-formatters/index", ["exports", "settings/utils/string-formatters/camel-to-snake", "settings/utils/string-formatters/dashed-to-camel", "settings/utils/string-formatters/remove-underscores", "settings/utils/string-formatters/snake-to-camel"], function (_exports, _camelToSnake, _dashedToCamel, _removeUnderscores, _snakeToCamel) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.defineProperty(_exports, "camelToSnake", {
    enumerable: true,
    get: function () {
      return _camelToSnake.default;
    }
  });
  Object.defineProperty(_exports, "dashedToCamel", {
    enumerable: true,
    get: function () {
      return _dashedToCamel.default;
    }
  });
  Object.defineProperty(_exports, "removeUnderscores", {
    enumerable: true,
    get: function () {
      return _removeUnderscores.default;
    }
  });
  Object.defineProperty(_exports, "snakeToCamel", {
    enumerable: true,
    get: function () {
      return _snakeToCamel.default;
    }
  });
  0; //eaimeta@70e063a35619d71f0,"settings/utils/string-formatters/camel-to-snake",0,"settings/utils/string-formatters/dashed-to-camel",0,"settings/utils/string-formatters/remove-underscores",0,"settings/utils/string-formatters/snake-to-camel"eaimeta@70e063a35619d71f
});